import React, { useState } from 'react';
import CustomerList from './components/customerList';
import CustomerModal from './components/customerModal';
import useCustomerState from './hooks/useCustomerState';
import { message } from 'antd';

const CustomerPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { customers, loading, addOrUpdate, markInactive } = useCustomerState();

  const [modalOpen, setModalOpen] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);

  const handleAdd = () => {
    setEditingCustomer(null);
    setModalOpen(true);
  };

  const handleEdit = (customer) => {
    setEditingCustomer(customer);
    setModalOpen(true);
  };

  const handleSave = async (customer) => {
    const response = await addOrUpdate(customer);
    if (response?.success) {
      setModalOpen(false);
      let toastMessage = 'Customer created successfully';
      if (editingCustomer && editingCustomer.id) {
        toastMessage = 'Customer updated successfully';
      }
      messageApi.success(toastMessage, 5);
    }
    return response;
  };

  const handleDelete = async (id, date) => {
    await markInactive(id, date);
  };

  return (
    <>
      {contextHolder}
      <CustomerList
        customers={customers}
        loading={loading}
        onEdit={handleEdit}
        markInactive={handleDelete}
        onAdd={handleAdd}
      />
      <CustomerModal
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSave={handleSave}
        initialData={editingCustomer}
      />
    </>
  );
};

export default CustomerPage;
